module.exports = __webpack_public_path__ + "static/media/spu_logo.2b13cc77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/spu_logo.svg
// module id = 484
// module chunks = 0